$(function() {

    const indexCardSlider = $("#index-card-slider #slider").flickity({
        wrapAround: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        cellAlign: "left",
        contain: true,
        imagesLoaded: true,
        on : {
            ready : function() {
                $("#index-card-slider #slider .flickity-slider").height($("#index-card-slider #slider .flickity-viewport").height())
                $("#index-card-slider .card__item__inner").height($("#index-card-slider .card__item__wrapper").height())
            }
        }
    })

    $(window).on("resize", function() {
        $("#index-card-slider #slider .flickity-slider").height($("#index-card-slider #slider .flickity-viewport").height())
        $("#index-card-slider .card__item__inner").height($("#index-card-slider .card__item__wrapper").height())
    })

    const bannerSlider = $(".banner__slider").flickity({
        wrapAround: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        cellSelector : ".banner__slider__item",
        fade: true,
        bgLazyLoad: true
    })
    const bannerSliderNav = $("#banner-slider-nav");

    $("#index-card-slider .flickity-control span").on("click", function() {
        flickityControl($(this), $(indexCardSlider));              
    })

    $(".banner__slider .flickity-control span").on("click", function() {
        flickityControl($(this), $(bannerSlider));  
        
        const selectedIndex = bannerSlider.data("flickity").selectedIndex;

        bannerSliderNav.find("span.active").removeClass("active");
        bannerSliderNav.find("span").eq(selectedIndex).addClass("active")
    })

    $("#banner-slider-nav").find("span").on("click", function() {
        const clickedIndex = $(this).index()
        bannerSlider.flickity("select", clickedIndex);   
        
        bannerSliderNav.find("span.active").removeClass("active");
        bannerSliderNav.find("span").eq(clickedIndex).addClass("active");
    })

})